import React from 'react'
import ComplexComp from '../../../components/Admin/complex'
import MasterLayoutAdmin from '../../../layout/Admin/masterLayoutAdmin'

export default function Complex() {
    return (
        <MasterLayoutAdmin>
            <ComplexComp />
        </MasterLayoutAdmin>
    )
}
